/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { XumoButton as Button, StackedContent } from 'ui';
import Image from 'next/image';

export interface CTATilesProps {
  bgImage?: string;
  center?: boolean;
  wide?: boolean;
  header?: any;
  contentLeft: any;
  contentRight: any;
  bgColor?: string;
  cardBgColor?: string;
  className?: string;
}

export const CTATiles = ({
  bgImage,
  center = true,
  wide = false,
  header,
  contentLeft,
  contentRight,
  bgColor = 'white',
  cardBgColor = 'white',
  className,
}: CTATilesProps) => {
  return (
    <section className={`${bgImage ? 'relative flex h-[1450px] w-full overflow-clip md:h-[1280px]' : 'h-fit'} bg-${bgColor}`} data-testid="text-section">
      {/* Image */}
      {bgImage && (
        <div className="absolute inset-0 z-0">
          <div className="relative h-full w-full">
            <Image src={bgImage} alt="" fill className="object-cover" />
            <div
              className="absolute inset-0 z-10"
              style={{
                background: 'linear-gradient(180deg, #140D13 0%, rgba(20, 13, 19, 0.80) 29%, rgba(20, 13, 19, 0.00) 100%)',
              }}
            />
          </div>
        </div>
      )}

      <div className={`wrapper relative z-20 mt-auto py-16 lg:py-32`}>
        {/* Header */}
        {header && (
          <div>
            <StackedContent center={center} mobileCenter={center} content={header} className={className} />
          </div>
        )}

        <div className={`grid grid-cols-1 ${wide ? 'gap-10' : 'gap-12 xl:gap-24'} xl:grid-cols-2`}>
          {/* Content left */}
          <div
            className={`min-h-[390px] rounded-2xl border-[0.5px] border-white bg-${cardBgColor} ${
              wide ? 'items-start px-6 py-12 md:px-12 md:py-12 xl:min-h-[600px]' : 'p-8 xl:min-h-[650px] xl:p-24'
            }`}
          >
            <StackedContent center={center} space content={contentLeft} className={className} />
          </div>

          {/* Content right */}
          <div
            className={`min-h-[390px] rounded-2xl border-[0.5px] border-white bg-${cardBgColor} ${
              wide ? 'px-6 py-12 md:px-12 md:py-12 xl:min-h-[600px]' : 'p-8 xl:min-h-[650px] xl:p-24'
            }`}
          >
            <StackedContent center={center} space content={contentRight} className={className} />
          </div>
        </div>
      </div>
    </section>
  );
};
